export const getElementWidth = (selector: string, parent: any = document) =>
  parent.querySelector(selector) ? parent.querySelector(selector).getBoundingClientRect().width : 0

export const getElementHeight = (selector: string, parent: any = document) =>
  parent.querySelector(selector) ? parent.querySelector(selector).getBoundingClientRect().height : 0

export const setElementStyle = (element: any, prop: string, value: string) =>
  !!element && !!value && (element['style'][prop] = value)
